<template>
  <div class="excellent-capabilities-introduce">
    <common-bg-plate>
      <detail-section title="增强能力说明">
        <el-row>
          <el-col v-for="(item, index) in list" :key="index" :span="8">
            <div :class="['introduce-info', item.class]">
              <div class="introduce-title">
                {{ item.name }}
              </div>
              <div class="introduce-introduce">
                {{ item.description }}
              </div>
            </div>
          </el-col>
        </el-row>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
export default {
  name: 'Introduce',
  data() {
    return {
      list: [
        {
          name: '多方安全计算',
          description:
            '该算法适用于多用户场景，由管理者输入陷门和总数生成N个密钥，并分发给不同的用户，管理者可以通过输入明文和公钥对明文进行加密，用户需要提供自己的私钥和密文来进行解密（提供的私钥数量需要和陷门数保持一致且有特定规则，否则无法解析密文）。',
          class: 'multi-secure-computing'
        },
        {
          name: '密文检索',
          description:
            '密文检索提供三种编码规则，纯英文，英文加数字组合和纯中文，首先选择一种编码规则生成密钥，用户可以多次传入关键词组合结合生成的密钥生成索引，同时通过传入搜索词组和密钥生成陷门，在搜索时，将陷门和之前生成的多个索引同时传入即可得到对应索引的评分，评分越高则表示该索引的关键词和陷门的关键词越相近。',
          class: 'ciphertext-retrieval'
        },
        {
          name: '属性加密',
          description:
            '由系统密钥、属性中心密钥和用户密钥三部分组成，需要初始化系统密钥，用户群体制定一个属性集合，结合系统公钥生成属性中心密钥。对于单独使用者需要指定一个用户id并且传入用户的属性集合（该属性集合需要是总属性集合的子集）获得用户密钥，随后任意使用者可以通过传入明文和属性规则对明文加密，规则例如（(属性1 AND 属性2) OR 属性3）这种，随后用户可以通过传入自己的私钥和密文进行解密，如果用户的私钥所包含的属性信息符合加密时传入的规则，则可以解密，反之则不能。',
          class: 'attribute-encryption'
        },
        {
          name: '零知识证明',
          description:
            '零知识证明的证明者能够在不向验证者提供任何有用的信息的情况下，使验证者相信某个论断是正确的。零知识证明实质上是一种涉及两方或更多方的协议，即两方或更多方完成一项任务所需采取的一系列步骤。证明者向验证者证明并使其相信自己知道或拥有某一消息，但证明过程不能向验证者泄漏任何关于被证明消息的信息。',
          class: 'zero-knowledge-proof'
        },
        {
          name: '同态加密',
          description:
            'Paillier算法是公钥加密体系的一个代表算法。但是，不同于传统的公钥加密算法，Paillier 算法除了实现对数据的公钥加密，还能保证在密文上直接进行加法操作，其结果解密后与在明文上进行操作的结果一样，因此Paillier算法完全的满足密文的加法同态性。除此之外，Paillier算法还支持明文和密文的乘法操作，具有良好的同态性，相比于当前的其他同态加密更加实用。',
          class: 'homomorphic-encryption'
        },
        {
          name: '身份层级加密',
          description:
            '身份分层加密是对属性加密的一种改进方案，它是一种由层级结构定义的属性加密。在传统的属性加密中，节点/用户之间没有层级结构关系，节点/用户的身份信息（属性）作为公钥，由密钥生成中心为每个节点/用户生成解密密钥并进行分配。HIBE 打破了传统的 IBE 方案，构造了一种层级结构关系，每一层节点/用户用来进行数据解密的解密密钥都由上一层级进行分配，也就是说，只有根节点/用户的密钥由 PKG 进行分配，这使得密钥的分配过程不再复杂，使得计算、权限分派变得简单，通信开销减少，适用于许多权限分级应用中。',
          class: 'identity-level-encryption'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme('excellent-capabilities-introduce', (
  --excellent-capabilities-introduce-color: #ffffff,
    --excellent-capabilities-introduce-background-color: #3a456d,
    --excellent-capabilities-introduce-content-detail-color: #E7E9F3
), (
  --excellent-capabilities-introduce-color: #192227,
  --excellent-capabilities-introduce-background-color: #f6f7f9,
  --excellent-capabilities-introduce-content-detail-color: #19222799
));
.excellent-capabilities-introduce {
  @include adaptation(
    (
      --excellent-capabilities-introduce-height: 434px,
      --excellent-capabilities-introduce-content-height: 171px,
      --excellent-capabilities-introduce-row-margin: 0 -12px,
      --excellent-capabilities-introduce-col-padding: 0 12px,
      --excellent-capabilities-introduce-col-margin-bottom: 16px,
      --excellent-capabilities-introduce-background-size: 215px 167px,
      --excellent-capabilities-introduce-content-border-radius: 4px,
      --excellent-capabilities-introduce-content-padding: 16px,
      --excellent-capabilities-introduce-content-title-font-size: 18px,
      --excellent-capabilities-introduce-content-title-margin-bottom: 12px,
      --excellent-capabilities-introduce-content-detail-font-size: 12px,
      --excellent-capabilities-introduce-content-detail-height: 103px
    )
  );
  .common-bg-plate {
    min-height: var(--excellent-capabilities-introduce-height);
    height: var(--excellent-capabilities-introduce-height);

    .el-row {
      margin: var(--excellent-capabilities-introduce-row-margin);

      .el-col {
        padding: var(--excellent-capabilities-introduce-col-padding);

        .introduce-info {
          color: var(--excellent-capabilities-introduce-color);
          height: var(--excellent-capabilities-introduce-content-height);
          background-color: var(--excellent-capabilities-introduce-background-color);
          background-size: var(--excellent-capabilities-introduce-background-size);
          background-repeat: no-repeat;
          background-position: right top;
          border-radius: var(--excellent-capabilities-introduce-content-border-radius);
          padding: var(--excellent-capabilities-introduce-content-padding);
          margin-bottom: var(--excellent-capabilities-introduce-col-margin-bottom);

          &.multi-secure-computing {
            background-image: url('~@/assets/images/excellent/multi-secure-computing.png');
          }
          &.ciphertext-retrieval {
            background-image: url('~@/assets/images/excellent/ciphertext-retrieval.png');
          }
          &.attribute-encryption {
            background-image: url('~@/assets/images/excellent/attribute-encryption.png');
          }
          &.zero-knowledge-proof {
            background-image: url('~@/assets/images/excellent/zero-knowledge-proof.png');
          }
          &.homomorphic-encryption {
            background-image: url('~@/assets/images/excellent/homomorphic-encryption.png');
          }
          &.identity-level-encryption {
            background-image: url('~@/assets/images/excellent/identity-level-encryption.png');
          }

          .introduce-title {
            font-size: var(--excellent-capabilities-introduce-content-title-font-size);
            font-weight: 500;
            margin-bottom: var(--excellent-capabilities-introduce-content-title-margin-bottom);
          }

          .introduce-introduce {
            color: var(--excellent-capabilities-introduce-content-detail-color);
            font-size: var(--excellent-capabilities-introduce-content-detail-font-size);
            overflow-y: auto;
            height: var(--excellent-capabilities-introduce-content-detail-height);
          }
        }
      }
    }
  }
}
</style>
